<template>
  <v-col class="pa-0">
    <v-card class="border card-info mt-2">
      <div class="pa-4">
        <div v-for="(item, index) in infoDevices1" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
        <div class="flex-container">
          <div class="label">
            <p>SIP статус</p>
          </div>
          <div class="border-left"></div>
          <div class="content">
              <span class="device-info">
                <v-icon x-small :color="gate.sip_status === '2' ? 'green' : 'red'">mdi-checkbox-blank-circle</v-icon>
                    {{ getSipStatus(gate.sip_status) }}
                    <v-btn
                      v-if="$checkPermission('update_gate')"
                      x-small
                      color="primary"
                      icon
                      :loading="isUpdatedSip"
                      @click.prevent="updateSipStatus()"
                    >
                    <v-icon small button color="primary">mdi-cached</v-icon>
                    </v-btn>
              </span>
          </div>
        </div>
        <div class="flex-container">
          <div class="label">
            <p></p>
          </div>
          <div class="border-left"></div>
          <div class="content">
            <history-sip-status-dialog
              :is-check-size-small="isCheckSizeSmall"
              type="gate"
              :sip-history="sipHistory"
            />
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoDevices2" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoDevices3" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import LabelValueInfo from '@/components/LabelValueInfo';
import historySipStatusDialog from '@/components/HistorySipStatusDialog';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LabelValueInfo, historySipStatusDialog },
  mixins: [ruDateFormatMixin],
  name: 'DetailedInfo',
  props: {
    gate: {
      type: Object,
      required: true,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
  },
  data () {
    return {
      dialogHistory: false,
      isUpdatedSip: false,
      sipHistory: [],
    };
  },
  created () {
    if (this.$checkPermission('view_sip_status_logs')) {
      this.getSipHistory(this.$route.params.id)
        .then((data) => {
          this.sipHistory = data;
        });
    }
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
    }),
    displayTitle () {
      return 'Калитка';
    },
    infoDevices1 () {
      return [
        { label: this.displayTitle, value: `${this.displayTitle} № ${this.gate.id}`, check: '1' },
        { label: 'Город', value: this.gate.address.split(' ')[0], check: this.gate.address, brCheck: true },
        { label: 'Район', value: this.gate.region_name, check: this.gate.region_name },
        { label: 'Дата установки', value: this.ruDateFormat(this.gate.created_at), check: this.gate.created_at },
        { label: 'Адрес', value: this.gate.address, check: this.gate.address },
      ];
    },
    infoDevices2 () {
      return [
        { label: 'Управляющая компания', value: this.gate.management_company, check: this.gate.management_company },
        { label: 'Агент', value: this.gate.agent, check: '1', brCheck: true },
        { label: 'Диспетчерская', value: this.gate.dispatcher_phone, check: this.gate.dispatcher_phone },
        { label: 'Физический статус', value: this.physicalStatus(this.gate.physical_status), check: this.gate.physical_status },
      ];
    },
    infoDevices3 () {
      return [
        { label: 'Название в моб. приложении', value: this.gate.name ? this.gate.name : '', check: '1' },
        { label: 'Видимость в моб. приложении', value: this.gate.display_in_app ? 'Отображается' : 'Скрыто', check: '1' },
        { label: 'Комметарий', value: this.gate.comment, check: this.gate.comment },
      ];
    },
  },
  methods: {
    ...mapActions({
      importSipStatus: 'Gate/getSipStatus',
      getGate: 'Gate/getWebInfoGate',
      getSipHistory: 'Gate/getSipHistory',
    }),
    updateSipStatus () {
      this.isUpdatedSip = true;
      this.importSipStatus(this.$route.params.id)
        .then(() => {
          this.$flash_success('SIP статус обновился!');
          this.getSipHistory(this.$route.params.id)
            .then((data) => {
              this.sipHistory = data;
            });
          this.getGate({
            id: this.$route.params.id,
          })
            .catch(() => {
              this.$flash_warning('Ошибка при загрузке информации');
            });
        })
        .catch(() => {
          this.$flash_warning('Не удолось обновить SIP статус');
        })
        .finally(() => {
          this.isUpdatedSip = false;
        });
    },
    getSipStatus (status) {
      switch (status) {
        case '1' : return ' (Доступен) ';
        case null : return ' (Не доступен) ';
        default: return '(Не известно)';
      }
    },
    physicalStatus (item) {
      switch (item) {
        case 1: return 'Установлен';
        case 2: return 'Не установлен';
        case 3: return 'Без интернет соединения';
        case 4: return 'Пусконаладка';
        case 5: return 'Старое устройство';
        default: return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.border {
  border-radius: 16px;
}
.border {
  border-radius: 16px;
}
.card-info {
  background-color: white;
  color: black;
  width: auto;
  box-shadow: none;
}
.btn-device-map {
  position: absolute;
  top: 10px;
  right: 25px;
}
.flex-container {
  display: flex;
}

.label {
  flex: 0 0 37%;
}

.border-left {
  border-left: 1px solid #707079;
}

.content {
  padding-left: 5px;
  display: block;
  word-wrap: break-word;
}

.device-info {
  font-weight: 400 !important;
  padding-left: 5px;
  font-size: 15px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
  font-weight: 400 !important;
  font-size: 15px !important;
  margin-bottom: 0 !important;
}
.btn-download-sip {
  position: absolute;
  right: 22%;
  height: 60%;
}
@media screen and (max-width: 800px) {
  .label {
    flex: 0 0 50%;
  }
  .device-info {
    font-size: 14px;
  }
  .content {
    padding-top: 5px;
  }
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
  .btn-download-sip {
    right: 11%;
  }
}
@media screen and (max-width: 800px) {
  .hist-but {}
}
@media screen and (max-width: 1000px) {
  .btn-device-map {
    top: 35px;
    right: 10px;
  }
}
</style>
